import type { SxProps, Theme } from '@mui/material';

export const rootStackSx: SxProps<Theme> = {
  width: '100%',
  alignItems: 'flex-start',
};

export const titleSx: SxProps<Theme> = {
  fontWeight: 600,
};

export const contentBoxSx: SxProps<Theme> = {
  width: '100%',
  minHeight: 320,
  position: 'relative',
};

export const cropperWrapperSx: SxProps<Theme> = {
  maxWidth: 500,
};

export const cropperBoxSx: SxProps<Theme> = {
  position: 'relative',
  height: 280,
  width: '100%',
  bgcolor: 'grey.100',
  borderRadius: 2,
  overflow: 'hidden',
  border: '1px solid',
  borderColor: 'divider',
};

export const controlsGridSx: SxProps<Theme> = {
  mt: 1.5,
  px: 1,
};
